var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-cy": "edit-file-link",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.01646 15.9998L4 19.2911C4 19.4766 4.06751 19.662 4.20274 19.7973C4.33798 19.9325 4.50591 20 4.6922 20L7.96647 19.9835C8.15191 19.9835 8.32069 19.9158 8.45592 19.7808L19.7636 8.47232C20.0338 8.20291 20.0338 7.76367 19.7636 7.47675L16.523 4.20269C16.2528 3.93244 15.8144 3.93244 15.5277 4.20269L13.2663 6.48139L4.2192 15.5103C4.10127 15.6453 4.01646 15.8143 4.01646 15.9998ZM16.0336 5.68772L18.3123 7.96642L17.03 9.2487L14.7513 6.97L16.0336 5.68772ZM5.41752 16.3038L13.7549 7.96642L16.0336 10.2451L7.69621 18.5652L5.40106 18.5825L5.41752 16.3038Z",
    fill: "#757783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic-pencil.4f201543.svg";
export { ForwardRef as ReactComponent };